import React from "react";
import get from "lodash/get";
import { useStoreState } from "app/state/store/hooks";

export const useUserSubInfo = () => {
  const storedUser = useStoreState((state) => get(state.user, "data.data", {}));
  const intercomUserId = useStoreState((state) =>
    get(state.IntercomUser, "data.data.id", "")
  );
  const stripeSubscriptionPlan = useStoreState(
    (state) => state.StripeSubscriptionPlan.data
  );

  const id = React.useMemo(() => get(storedUser, "user_id", ""), [storedUser]);
  const email = React.useMemo(() => get(storedUser, "email", ""), [storedUser]);
  const groupId = React.useMemo(() => get(storedUser, "groupId"), [storedUser]);
  const apiKey = React.useMemo(
    () => get(storedUser, "app_metadata.registryApiKey", ""),
    [storedUser]
  );
  const publisherId = React.useMemo(
    () => get(storedUser, "app_metadata.publisherID", ""),
    [storedUser]
  );
  const orgRef = React.useMemo(
    () => get(storedUser, "app_metadata.publisherInfo.publisher_iati_id", ""),
    [storedUser]
  );
  const isAdmin = React.useMemo(
    () => get(storedUser, "app_metadata.role") === "Admin",
    [storedUser]
  );
  const isOnFreePlan = React.useMemo(() => {
    const plan = get(stripeSubscriptionPlan, "data.plan", "free").toLowerCase();
    if (plan === "free") {
      const oldPlan = get(
        storedUser,
        "app_metadata.pricingPlan.name",
        "Free"
      ).toLowerCase();
      return oldPlan === "free";
    }
    return false;
  }, [stripeSubscriptionPlan, storedUser]);

  const subscriptionPlan = React.useMemo(() => {
    const oldVersionPlan = get(
      storedUser,
      "app_metadata.pricingPlan.name",
      "Free"
    );
    const newVersionPlan = get(
      stripeSubscriptionPlan,
      "data.plan",
      "free"
    ).toLowerCase();
    if (newVersionPlan && newVersionPlan !== "free") {
      return newVersionPlan;
    }
    return oldVersionPlan.toLowerCase();
  }, [stripeSubscriptionPlan, storedUser]);

  const licenses = React.useMemo(() => {
    let result = get(stripeSubscriptionPlan, "data.licenses", 0);
    if (result === 0) {
      result = get(storedUser, "app_metadata.pricingPlan.licenses", 0);
    }
    return result;
  }, [storedUser, stripeSubscriptionPlan]);

  const support = React.useMemo(() => {
    let result = get(stripeSubscriptionPlan, "data.support", false);
    if (result === false) {
      result = get(storedUser, "app_metadata.pricingPlan.support", false);
    }
    return result;
  }, [storedUser, stripeSubscriptionPlan]);

  return {
    id,
    email,
    apiKey,
    orgRef,
    support,
    groupId,
    isAdmin,
    licenses,
    publisherId,
    isOnFreePlan,
    intercomUserId,
    subscriptionPlan,
  };
};
